import React from "react"
import classnames from "@utils/classnames"
import styles from "./logos.module.scss"

const Logos = React.memo(({ total, urlPrefix }) => {
  return (
    <div className={styles.container}>
      {new Array(total).fill("").map((_, i) => {
        return (
          <div key={i}>
            <img src={`${urlPrefix}${i + 1}.png`} alt="logo" />
          </div>
        )
      })}
    </div>
  )
})

Logos.displayName = "Logos"
export default Logos
